import { mdiArrowRight } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import Lottie from 'lottie-react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { connect, useDispatch, useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import { SUBSCRIBER_FEATURES } from '../../../../constants';
import { planSelection, subscriptionInitiate } from '../../../../helpers/datalayer-utils';
import {
  checkForSubscription,
  getPaymentOptionsAndPay,
  getSSOLoginUrl,
  getSSORedirectUrl,
  getSubscriptionParams,
  setUser,
} from '../../../../helpers/subscription-helper';
import { getCookies, setCookies } from '../../../../helpers/utils';
import ShineButton from '../../../atoms/shine-button';
import BenifitsCard from '../../subscription/profit-subscription/benifits-card';
import SubscriberIcon from '../../subscription/profit-subscription/hard-paywall-card/card-lottie.json';
import SubscribeModal from '../subscribe/subscribeModal';
import SubscriptionOfferShimmer from './subscription-offer-shimmer';
import './subscription-offer.m.css';

const SubscriptionOffer = ({ images, integrations, features, isSubscriber, ...props }) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [isSubscriberLoading, setSubscriberLoading] = useState(true);
  const { subscriptionPlans, custom_attributes } = props?.data;
  const { subscription_offer } = features;
  const offerParams = subscription_offer?.offerParams;
  const [isActive, setActive] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();
  const [showPlanStripe, setShowPlanStripe] = useState(false);

  const isLoggedIn = useSelector((state) => get(state, ['userData', 'isLoggedIn'], null));
  const userInfo = useSelector((state) => get(state, ['userData', 'userProfile'], null));
  const userSubscription = useSelector((state) =>
    get(state, ['userData', 'userSubscription'], null),
  );
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const SSO_LOGIN_URL = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'subscription', 'login_url'], null),
  );

  useEffect(() => {
    if (isSubscriber === null) {
      setSubscriberLoading(true);
    } else {
      setSubscriberLoading(false);
    }
  }, [isSubscriber]);

  useEffect(() => {
    if (props?.data) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [props?.data]);

  const DesktopBanner =
    custom_attributes?.find((item) => item?.name === 'Desktop Banner Image' && item?.value !== null)
      ?.value || get(subscription_offer, ['images', 'DesktopBanner'], null);
  const MobileBanner =
    custom_attributes?.find((item) => item?.name === 'Mobile Banner Image' && item?.value !== null)
      ?.value || get(subscription_offer, ['images', 'MobileBanner'], null);
  const DesktopBackground =
    custom_attributes?.find(
      (item) => item?.name === 'Desktop Background Image' && item?.value !== null,
    )?.value || get(subscription_offer, ['images', 'DesktopBackground'], null);

  const TopPick = (custom_attributes) => {
    return custom_attributes?.find((item) => item?.name === 'Top Pick' && item?.value !== null)
      ?.value;
  };
  const BasePrice = (custom_attributes) => {
    return custom_attributes?.find((item) => item?.name === 'Base Price' && item?.value !== null)
      ?.value;
  };
  const OfferPrice = (custom_attributes) => {
    return custom_attributes?.find((item) => item?.name === 'Offer Price' && item?.value !== null)
      ?.value;
  };
  const isValidOffer = (urlParams) =>
    Array.from(new URLSearchParams(urlParams)?.keys())?.some((key) => offerParams?.includes(key));
  useEffect(() => {
    setSubscriberLoading(false);
    setLoading(props?.data ? false : isLoading);
    let currentParams = window?.location?.search;
    if (currentParams !== '') {
      if (isValidOffer(currentParams)) {
        setCookies('SEARCH_PARAMS', currentParams, 1);
      } else {
        if (!currentParams?.includes('authorizationCode')) {
          window.location.href = '/subscription';
        }
      }
    } else {
      currentParams = getCookies('SEARCH_PARAMS');
      if (!currentParams || !isValidOffer(currentParams)) {
        if (!currentParams?.includes('authorizationCode')) {
          window.location.href = '/subscription';
        }
      }
    }

    const defaultActivePlanIndex = subscription_offer?.defaultActivePlanIndex || 1;

    if (subscriptionPlans?.length > 0) {
      setSelectedPlan(subscriptionPlans[defaultActivePlanIndex]);
      setLoading(false);
    } else {
      window.location.href = '/subscription';
    }
  }, [isSubscriber]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    const handleScroll = () => {
      const mainContent = document.getElementById('main-content');
      if (!mainContent) return;

      const rect = mainContent.getBoundingClientRect();
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;

      setShowPlanStripe(!isVisible);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  };
  const handlePayment = async (plan) => {
    // setPaymentLoader(true);
    try {
      setLoading(true);
      const params = await getSubscriptionParams(plan, userInfo);
      await setUser(userInfo);
      await getPaymentOptionsAndPay(params, 'razorpay', onPaymentSuccess, onPaymentFailure);
    } catch (e) {
      console.error('Payment Error:', e);
      setLoading(false);
    }
  };
  const onPaymentSuccess = async (subscription) => {
    await setActiveSubscription(subscription);
    await setOpen(true);

    setLoading(false);
  };

  const onPaymentFailure = () => {
    setLoading(false);
  };

  const signIn = () => {
    const url = new URL(window?.location?.href);
    getSSORedirectUrl(url).then((redirectUrl) => {
      getSSOLoginUrl(
        integrations?.sso?.client_id,
        integrations?.sso?.client_secret,
        redirectUrl,
        SSO_LOGIN_URL,
      ).then((pageUrl) => {
        window.location = pageUrl;
      });
    });
  };

  const handleSubscription = async (plan) => {
    await localStorage.setItem('USER_SELECTED_PLAN', JSON.stringify(plan));
    if (!isLoggedIn) {
      signIn();
    } else {
      planSelection(userData, pageType, plan.title, plan.price_cents / 100);
      subscriptionInitiate(userData, 'section-page', '', '', plan.price_cents / 100);
      handlePlanSelect(plan);
      handlePayment(plan);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      const timer = setInterval(() => {
        const atToken = localStorage.getItem('UserAccesstypeJwtToken');
        if (!!atToken) {
          checkForSubscription(dispatch, atToken).then(({ purchasedSubscription, isChurnUser }) => {
            if (!purchasedSubscription) {
              const accesstype = integrations.accesstype;
              const script = document.createElement('script');
              script.id = 'accesstype';
              script.src = `${accesstype.host}/frontend/v2/accesstype.js?key=${accesstype.accountId}${accesstype['env-sandbox'] && accesstype['env-sandbox'].enabled ? '&env=sandbox' : ''}`;
              script.async = true;
              script.defer = true;
              script.type = 'text/javascript';
              document.head.appendChild(script);
              return async () => {
                await unsetUser(dispatch);
                document.head.removeChild(script);
              };
            }
          });
          clearInterval(timer);
        }
      }, 1000);
    }
  }, [isLoggedIn]);

  const handleClick = (id) => {
    scroller.scrollTo(id, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 0,
    });
  };

  const SubscriptionTheme = () => {
    return (
      <div styleName={isSubscriber ? 'subscription-theme mb-theme' : 'subscription-theme'}>
        <img src="/images/story_top_img.svg" styleName="top-banner" />
        <div styleName="non-subscriber-wrap">
          <Lottie animationData={SubscriberIcon} loop={true} autoplay={true} />
          <h1 styleName="heading">You are already </h1>
          <h1 styleName="subscriber-text">
            a <span>Subscriber</span>
          </h1>
          {userSubscription?.active && (
            <>
              <div styleName="exp-text">Subscription Expires on </div>
              <div styleName="exp-date">
                {moment(userSubscription?.active?.end_timestamp).format('MMMM DD, YYYY')}
              </div>
            </>
          )}
          <a href="/" styleName="back-btn">
            Back to Homepage <Icon path={mdiArrowRight} size={'18px'} />
          </a>
        </div>
      </div>
    );
  };

  if (isLoading || isSubscriberLoading) {
    return <SubscriptionOfferShimmer />;
  }

  return (
    <>
      <div styleName="subscription-container" id="subscription-home">
        <div styleName={isSubscriber ? 'headerBanner hideBanner' : 'headerBanner'}>
          {DesktopBanner && !isSubscriber && (
            <img
              src={DesktopBanner}
              height="186px"
              width="100%"
              className="desktop-only"
              alt="Banner"
              onLoad={() => setLoading(false)}
            />
          )}
          {MobileBanner && !isSubscriber && (
            <img
              src={MobileBanner}
              height="100%"
              width="100%"
              className="mobile-only"
              alt="Banner"
              onLoad={() => setLoading(false)}
            />
          )}
        </div>
        {DesktopBackground && (
          <img
            src={DesktopBackground}
            height="141px"
            width="100%"
            className="desktop-only"
            alt="Background"
            onLoad={() => setLoading(false)}
          />
        )}
        <div styleName="main-content" id="main-content">
          {!isSubscriber && !isSubscriberLoading && (
            <div styleName="plans-section">
              <div styleName="choose-plan">
                <img src="/images/subscription-icon.svg" styleName="heading" />
                CHOOSE A PLAN
                <img src="/images/subscription-icon.svg" styleName="heading" />
              </div>
              {!isMobile ? (
                <div styleName="plans" className="desktop-only">
                  {subscriptionPlans?.map((plan, index) => {
                    const basePrice = Number(BasePrice(plan?.custom_attributes));
                    const offerPrice = Number(OfferPrice(plan?.custom_attributes));
                    const [date, year, ...remaining] = plan?.title?.split(' ');
                    const remainingText = remaining?.join(' ') || '';
                    return (
                      <div
                        key={index}
                        styleName={`${TopPick(plan?.custom_attributes) === 'True' ? 'plan checked' : 'plan'}`}
                      >
                        <div styleName="duration">
                          {TopPick(plan?.custom_attributes) === 'True' && (
                            <div styleName="badge">TOP PICK</div>
                          )}
                          <strong styleName="date">{date || plan?.title}</strong>
                          <span styleName="month">
                            {year + ' ' + remainingText || plan?.duration_unit}
                          </span>
                        </div>
                        <div styleName="price-section">
                          {plan?.custom_attributes?.length > 0 && (
                            <div styleName="price">
                              {basePrice !== 'NaN' && (
                                <span styleName="old-price">₹{basePrice}</span>
                              )}
                              {offerPrice !== 'NaN' && `₹${offerPrice}/month`}
                            </div>
                          )}
                          <div styleName="new-price">You pay ₹{plan?.price_cents / 100}</div>
                          <ShineButton
                            className="shine-button"
                            size="medium"
                            label="Continue"
                            onClick={() => handleSubscription(plan)}
                            isShine={TopPick(plan?.custom_attributes) === 'True' ? true : false}
                          >
                            <div styleName="svg-wrapper">
                              <Icon path={mdiArrowRight} size={'20px'} />
                            </div>
                          </ShineButton>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <>
                  {subscriptionPlans?.map((plan, index) => {
                    const basePrice = Number(BasePrice(plan?.custom_attributes));
                    const offerPrice = Number(OfferPrice(plan?.custom_attributes));
                    return (
                      <div
                        styleName={
                          selectedPlan?.id === plan?.id ? 'mobile-plans selected' : 'mobile-plans'
                        }
                        className="mobile-only"
                        key={index}
                        onClick={() => handlePlanSelect(plan)}
                      >
                        <div styleName="duration-section">
                          <div styleName="month">
                            {plan?.title}
                            {TopPick(plan?.custom_attributes) === 'True' && (
                              <div styleName="label">TOP PICK</div>
                            )}
                          </div>
                          <div styleName="price">
                            You pay <span>₹{plan?.price_cents / 100}</span>
                          </div>
                        </div>
                        <div styleName="price-section">
                          {plan?.custom_attributes?.length > 0 && (
                            <strong styleName="price">
                              {basePrice !== 'NaN' && (
                                <span styleName="discount">₹{basePrice}</span>
                              )}
                              {offerPrice !== 'NaN' && `₹${offerPrice}`}
                              <span>/month</span>
                            </strong>
                          )}
                          <img
                            src={
                              selectedPlan?.id === plan?.id
                                ? '/icons/ic_radio_button_checked_24px.svg'
                                : '/icons/ic_radio_button_unchecked_24px.svg'
                            }
                            height="23px"
                            width="23px"
                          />
                        </div>
                      </div>
                    );
                  })}
                  <div styleName="btn-section" className="mobile-only">
                    <ShineButton
                      className="shine-button"
                      size="medium"
                      label={`Continue at ₹${selectedPlan?.price_cents / 100}`}
                      onClick={() => (!isLoggedIn ? signIn() : handleSubscription(selectedPlan))}
                    >
                      <div styleName="svg-wrapper">
                        <Icon path={mdiArrowRight} size={'20px'} />
                      </div>
                    </ShineButton>
                    <span styleName="desc">Renews automatically. Cancel anytime.</span>
                  </div>
                </>
              )}
            </div>
          )}
          {isSubscriber && <SubscriptionTheme />}

          {/* Benefits section */}
          <div styleName="headerText" className="container desktop-only">
            <div styleName="line"></div>
            <div styleName="heading">
              <img src="/images/subscription-icon.svg" styleName="heading" />
              SUBSCRIBER BENEFITS
              <img src="/images/subscription-icon.svg" styleName="heading" />
            </div>
            <div styleName="line"></div>
          </div>
          {isMobile ? (
            <div className="mobile-only" styleName="sm-benefits">
              <BenifitsCard setActive={setActive} isActive={isActive} />
            </div>
          ) : (
            <Marquee gradient={false} speed={50} style={{ overflow: 'hidden' }}>
              {SUBSCRIBER_FEATURES.map((benefit, i) => (
                <div styleName="benefit" key={i}>
                  <img
                    src={benefit.link2}
                    styleName="icon"
                    alt={benefit.title}
                    style={{
                      width: benefit.width || '40px',
                      height: benefit.height || '40px',
                    }}
                  />
                  <div styleName="text">
                    <strong styleName="title">{benefit.title}</strong>
                    {benefit.desc === 'Bloomberg' ? (
                      <div styleName="desc-bloomberg">
                        <img src="/icons/Bloomberg_grey.svg" alt={benefit.desc} />
                        Stories
                      </div>
                    ) : (
                      <p styleName="desc">{benefit.desc}</p>
                    )}
                  </div>
                </div>
              ))}
            </Marquee>
          )}
          <div styleName={`shadow ${!isActive ? 'shadow-none' : ''}`} className="mobile-only"></div>
        </div>
        {selectedPlan && isMobile && showPlanStripe && !isSubscriber && (
          <div className="mobile-only" id="plan-stripe" styleName="plan-stripe">
            <div styleName="plan">
              <div styleName="duration">
                {selectedPlan?.title}
                <span onClick={() => handleClick('subscription-home')}>Change</span>
              </div>
              <div styleName="price">
                Billed Amount <span>₹{selectedPlan?.price_cents / 100}</span>
              </div>
            </div>
            <ShineButton
              className="shine-button"
              size="medium"
              label="Continue"
              rounded="full"
              onClick={() => (!isLoggedIn ? signIn() : handleSubscription(selectedPlan))}
            >
              <div styleName="svg-wrapper">
                <Icon path={mdiArrowRight} size={'20px'} />
              </div>
            </ShineButton>
          </div>
        )}
        <img
          src="/images/web-bottom.svg"
          alt="web-bottom"
          styleName="web-bottom"
          className="mobile-only"
        />
      </div>
      {isOpen && (
        <SubscribeModal isOpen={isOpen} setOpen={setOpen} subscription={activeSubscription} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  images: get(state, ['qt', 'config', 'features', 'subscription_offer'], {}),
  integrations: state.qt.config['integrations'],
  features: state.qt.config['features'],
});

export default connect(mapStateToProps)(SubscriptionOffer);
